import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Router keeps scroll position between routes; legal pages should start at the top. */
function ScrollTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}

export default ScrollTop;
